import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { MainViewStore, MainViewState, LoadFunction } from '../../helpers/types';

@Component({
  selector: 'app-results-per-page',
  templateUrl: './results-per-page.component.html',
  styles: ['.uk-select.uk-form-width-xsmall.uk-form-small.elements-per-page-select { height: 24px; }']
})
export class ResultsPerPageComponent implements OnInit {
  limit: number;
  @Input() component: string;
  @Input() loadFunction: LoadFunction;
  @Input() state: Observable<MainViewState>;

  constructor(private store: Store<MainViewStore>) {}

  ngOnInit(): void {
    this.limit = +localStorage.getItem(`${this.component}Limit`) || 40;
  }

  handleChange(event: Event): void {
    localStorage.setItem(`${this.component}Limit`, (event.target as HTMLSelectElement).value);

    this.state.pipe(take(1)).subscribe((state: MainViewState) => {
      const params = {
        ...state.params,
        offset: 0,
        limit: +(event.target as HTMLSelectElement).value
      };
      this.store.dispatch(this.loadFunction(params));
    });
  }
}
